/*
submenu = {
  "links": [
    "gid://shopify/Metaobject/157355409469",
    "gid://shopify/Metaobject/157355475005",
    "gid://shopify/Metaobject/157355540541",
    "gid://shopify/Metaobject/157355573309"
  ],
  "name": "Civil collection"
}
*/


const STOREFRONT_URL = 'https://fearofgod.com/api/graphql';
const STOREFRONT_HEADERS = {
  'X-Shopify-Storefront-Access-Token': 'e3402e5885c3ee4f9e7fa4743ede7d4b',
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};

const QUERIES = {
  metaobject: `
    query metaobjectById($id: ID!) {
      metaobject(id: $id) {
        id
        type
        handle
        name: field(key: "name") { value }
        page: field(key: "page") { value }
        collection: field(key: "collection") { value }
      }
    }
  `,
  page: `
    query pageById($id: ID!) {
      page(id: $id) {
        id
        handle
      }
    }
  `,
  collection: `
    query collectionById($id: ID!) {
      collection(id: $id) {
        id
        handle
      }
    }
  `,
};

/**
 * @param {Object} query
 * @param {Object} variables
 */
async function storefrontFetch(query, variables) {
  const res = await fetch(STOREFRONT_URL, {
    method: 'POST',
    headers: STOREFRONT_HEADERS,
    body: JSON.stringify({ query, variables }),
  });
  return res.json();
}

/**
 * @param {string} link
 * @param {number} index
 */

async function resolveSubmenuLink(link, index) {
  const { data: metaData } = await storefrontFetch(QUERIES.metaobject, { id: link });
  const metaobject = metaData?.metaobject;
  if (!metaobject) return null;

  console.log('metaobject',metaobject)
  const isPageLink = metaobject.type === 'submenu_page_link';
  const query = isPageLink ? QUERIES.page : QUERIES.collection;
  const id = isPageLink
    ? metaobject.page.value.replace('OnlineStorePage', 'Page')
    : metaobject.collection.value;

  const { data: linkData } = await storefrontFetch(query, { id });
  const handle = isPageLink ? linkData.page.handle : linkData.collection.handle;
  const url = isPageLink ? `/pages/${handle}` : `/collections/${handle}`;

  return { index, id: link, name: metaobject.name.value, url };
}

/**
 * @param {{ url: string, name: string }[]} submenuData
 */
function buildSubmenu(submenuData) {
  console.log('submenuData', submenuData);
  const container = document.querySelector('.submenu');
  if (!container) return;
  container.innerHTML = '';

  if(submenu.hasOwnProperty('name') && !submenu.hasOwnProperty('parent_collection')) {
    const span = document.createElement('span');
    span.innerHTML = `<span class="trim-both">${submenu.name}</span>`;
    span.classList.add('submenu-name');
    container.appendChild(span);

    const spanDivider = document.createElement('span');
    spanDivider.innerText = "/";
    container.appendChild(spanDivider);
  }

  if(submenu.hasOwnProperty('parent_collection') && submenuData.parentCollection) {
    const a = document.createElement('a');
    a.href = submenuData.parentCollection.url;
    a.innerHTML = `<span class="trim-both">${submenuData.parentCollection.name}</span>`;
    a.classList.add('submenu-parent-collection');
    container.appendChild(a);

    const spanDivider = document.createElement('span');
    spanDivider.innerHTML = `<span class="trim-both">/</span>`;
    container.appendChild(spanDivider);
  }


  submenuData.links.forEach(({ url, name }) => {
    const a = document.createElement('a');
    a.href = url;
    a.innerHTML = `<span class="trim-both">${name}</span>`;
    if (window.location.pathname === url) a.classList.add('active');
    container.appendChild(a);
  });

  if(submenu.hasOwnProperty('fit_guide') && submenuData.fitGuide) {
    const a = document.createElement('a');
    a.href = submenuData.fitGuide.url;
    a.innerHTML = `<span class="trim-both">${submenuData.fitGuide.name}</span>`;
    a.classList.add('submenu-fit-guide');
    container.appendChild(a);
  }
}

async function initSubmenu() {
  try {
    // @ts-ignore
    const results = await Promise.all(submenu.links.map(resolveSubmenuLink));
    // Filter out any null results (in case of errors) and sort by original index
    const links = results
      .filter(Boolean)
      .sort((a, b) => a.index - b.index);

    let parentCollection = null;
    if(submenu.hasOwnProperty('parent_collection')) {
      parentCollection = await resolveSubmenuLink(submenu.parent_collection, -1);
    }

    let fitGuide = null;
    if(submenu.hasOwnProperty('fit_guide')) {
      fitGuide = await resolveSubmenuLink(submenu.fit_guide, -1);
    }

    const submenuData = {
      parentCollection: parentCollection,
      fitGuide: fitGuide,
      links: links
    }
    buildSubmenu(submenuData);

    document.querySelector('.collection-submenu a.active').scrollIntoView(
      {
        behavior: 'auto',
        block: 'nearest',
        inline: 'nearest'
      }
    );
  } catch (err) {
    console.error('Failed to build submenu:', err);
  }
}

initSubmenu();